import React, { useState } from 'react'
import propTypes from 'prop-types'

import { InviteFriendsModal } from '../../Modal/InviteFriendsModal'
import { Button } from '../../Button'

export const InviteButton = ({ referralsPath, fullWidth }) => {
  const [inviteModalOpen, setInviteModalOpen] = useState(false)
  return (
    <>
      <InviteFriendsModal
        open={inviteModalOpen}
        close={() => setInviteModalOpen(false)}
        referralsPath={referralsPath}
      />
      <Button fullWidth={fullWidth} secondary onClick={() => setInviteModalOpen(true)}>Invite Friends</Button>
    </>
  )
}

InviteButton.propTypes = {
  referralsPath: propTypes.string.isRequired,
  fullWidth: propTypes.bool
}
